module.exports = __webpack_public_path__ + "media/images/gift/gift-ex1-fcf9f91a2d58a07d94f4c5f99d9ebda8.png";